var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['zg-close-button', {
    [`zg-close-button--size-${_vm.size}`]: _vm.size
  }],attrs:{"type":"button"}},[_c('span',{staticClass:"visually-hidden"},[_vm._v("\n    Click to close\n  ")]),_vm._v(" "),_c('zg-icon',{attrs:{"icon":"close","size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }